
import { contactImages } from '../../../utils/images';

export default function HeroSection() {
  return (
    <section className="relative h-[400px] bg-gray-900 text-white overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('${contactImages.placeholder}')`
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
        <div className="w-full text-center">
          <h1 className="text-4xl lg:text-5xl font-light mb-4 leading-tight">
            Get In Touch
          </h1>
          <p className="text-lg text-gray-200 max-w-2xl mx-auto font-light leading-relaxed">
            We'd love to hear from you. Whether you're a brand, wholesaler, or importer, Musheng is ready to support your next project.
          </p>
        </div>
      </div>
    </section>
  );
}
